import { ICON } from '@core/util/icon';
export class Waze {
	label: string;
	url: string;
	icon: ICON;
	show: boolean;
	id: number;
	links: Waze[];

	constructor(label: string, show: boolean) {
		this.label = label;
		this.show = show;
	}
	withIcon(icon: ICON) {
		this.icon = icon;
		return this;
	}
	withPath(url: string) {
		this.url = url;
		return this;
	}
	withChildren(children: Waze[]) {
		this.links = children;
		return this;
	}
	withId(id: number) {
		this.id = id;
		return this;
	}
}
